import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import cup from "../../../../../assets/images/cup 2.png";
import AllDataHeader from "../../../../Reuseable/AllDataHeader";
import LoaderPost from "../../../../Reuseable/LoaderPost";
import AuditionStatus from "./AuditionStatus";

const LiveAuditionSliderStar = () => {
  let history = useHistory();

  const [liveAuditions, setLiveAudition] = useState([]);
  const [buffer, setBuffer] = useState(true);

  useEffect(() => {
    axios.get(`/api/superstar/audition/live`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setLiveAudition(res.data.liveAuditions);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader title="Live Auditions" image={cup} count={"Zero"} />
      {buffer ? (
        <LoaderPost />
      ) : (
        <AuditionStatus
          data={liveAuditions}
          showVideoUrl={`/superstar/auditions/round-video-marking`}
          viewUrl={`/superstar/auditions/description`}
          roundUrl={`/superstar/auditions/round-instruction`}
        />
      )}
    </>
  );
};

export default LiveAuditionSliderStar;
